<template>
  <div class="referenceInformation">
    <div style="overflow:auto;height: 410px" v-if="referList.length">
      <table border="1" cellspacing="0">
        <tr>
          <td v-if="this.isShowTHeade && this.groupList.length"></td>
          <td v-if="chekResultList.hasOwnProperty(item.key)" v-for="(item,index) in groupList" :key="index">{{ item.value }}</td>
        </tr>
        <tr v-for="(item,index) in referList" :key="index">
          <td>{{ item.referenceFieldKey }}</td>
          <td v-if="chekResultList.hasOwnProperty(it.referenceGroupId)" v-for="(it,ind) in item.referenceValueList" :key="ind">{{ it.referenceFieldValue }}</td>
        </tr>
      </table>
    </div>
    <template v-else>
        <span class="no-data">
            <p>暂无参考信息</p>
            <img src="./img/no-result.png" alt="暂无就诊数据"/>
        </span>
    </template>
    <el-dialog
        title="请先阅读参考信息"
        :visible.sync="dialogVisible"
        :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false"
        width="40%" v-if="referList.length"
    >
      <div style="height: 400px; overflow: auto">
        <div class="referenceInfoDialog">
          <table border="1" cellspacing="0">
            <tr>
              <td v-if="this.isShowTHeade && this.groupList.length"></td>
              <td v-if="chekResultList.hasOwnProperty(item.key)" v-for="(item,index) in groupList" :key="index">{{ item.value }}</td>
            </tr>
            <tr v-for="(item,index) in referList" :key="index">
              <td>{{ item.referenceFieldKey }}</td>
              <td v-if="chekResultList.hasOwnProperty(it.referenceGroupId)" v-for="(it,ind) in item.referenceValueList" :key="ind">{{ it.referenceFieldValue }}</td>
            </tr>
          </table>
        </div>
        <div class="i-known">
          <el-button type="success" round size="medium" @click="dialogVisible = false">我已知晓，开始随访</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { RestReferenceControllerGetReferenceInfo } from "@src/assets/js/api.js"

export default {
  name: "referenceInformation",
  props: ['patientData'],
  data() {
    return {
      isShowTHeade: false,
      chekResultList: [],
      referenceInfo: [],
      referList: [],
      groupList: [],
      dialogVisible: true
    }
  },
  mounted() {
    this.init()
    // this.getReferenceInfo()

    this.getReferenceGroupList({
      followUpTaskId: localStorage.getItem('taskId')
    })
        .then((res) => {
          this.groupList = res.retValue
          this.getPatientReferenceInfo()
        })
  },
  methods: {
    checkGroupIsEmpty() {
      let obj = {

      }
      this.referList.forEach(item => {
        item.referenceValueList.forEach(it => {
          if(it.referenceFieldValue &&obj.hasOwnProperty(it.referenceGroupId)) {
            obj[it.referenceGroupId].push(it.referenceFieldValue)
          }else if(it.referenceFieldValue && !obj.hasOwnProperty(it.referenceGroupId)) {
            obj[it.referenceGroupId] = [it.referenceFieldValue]
          }
        })
      })
      this.chekResultList = obj
    },
    init() {
      // this.patientData.isReferenceRead.log
      this.dialogVisible = this.patientData.isReferenceRead
    },
    getReferenceInfo() {
      this.getReferenceInfoAsync()
          .then(res => {
            this.referenceInfo = res.retValue.keyValue ? JSON.parse(res.retValue.keyValue) : []
          })
      // }

      this.$forceUpdate()
    },
    isShowTHeader() {
      this.isShowTHeade = false
      this.referList.forEach(item => {
        item.referenceValueList.forEach(it => {
          if(it.referenceFieldValue) {
            this.isShowTHeade = true
          }
        })
      })
      console.log(this.isShowTHeade);
    },
    //===========================req================================
    async getReferenceInfoAsync() {
      let request = new RestReferenceControllerGetReferenceInfo()
      request.p_followupPatientId = this.patientData.followupPatientId
      request.p_taskId = localStorage.getItem('taskId')
      // request.p_taskId =
      await request.send()
      return request.result
    },
    async getReferenceGroupList() {
      let result = await this.$store.dispatch('requestHandler', {
        fn: 'RestReferenceControllerGetReferenceGroupList',
        params: {
          followUpTaskId: localStorage.getItem('taskId')
        }
      })
      return result
    },
    getPatientReferenceInfo() {
      this.getPatientReferenceInfoAsync({
        followUpTaskId: localStorage.getItem('taskId'),
        followupPatientId: this.patientData.followupPatientId
      }).then(res => {
        this.referList = res.retValue
        this.checkGroupIsEmpty()
        this.isShowTHeader()
      })
    },
    async getPatientReferenceInfoAsync(p) {
      let result = this.$store.dispatch('requestHandler', {
        fn: 'RestReferenceControllerGetPatientReferenceInfo',
        params: {
          followUpTaskId: p.followUpTaskId,
          followupPatientId: p.followupPatientId,
        }
      })
      return result
    }
  },
}
</script>

<style lang="scss" scoped>
*::-webkit-scrollbar {
  height: 5px
}
table {
  border-collapse: collapse;
  width: 100%;
}

th, td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
}

th {
  background-color: #fafafa;
}

/* 左侧列固定 */
th:first-child, td:first-child {
  position: sticky;
  left: 0;
  z-index: 1;
  background-color: #fafafa;
}
table{
  border-top: 1px solid #000000;
  border-left: 1px solid #000000;
  border-collapse: collapse; /*设置单元格的边框合并为1*/
}
td{
  border-bottom: 1px solid #000000;
  border-right: 1px solid #000000;
}
table {
  td {
    width: 120px;
    padding: 10px;
  }
}

.no-data {
  p {
    margin: 40px 0 80px;
    font-size: 16px;
    color: rgba(0, 0, 0, 1);
  }

  display: table-cell;
  height: 60vh;
  vertical-align: middle;
  text-align: center;
  width: 480px;
  height: 100%;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.16), 0px 0px 2px 0px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  padding: 15px 15px 15px 20px;
  box-sizing: border-box;
  margin-top: 20px;
  margin-bottom: 20px;

}

.item {
  display: flex;
  align-items: center;
  justify-content: space-around;
  border-bottom: 1px solid #ccc;

  &:last-child {
    border-bottom: none;
  }

  .item-left {
    width: 50%;
    border-right: 1px solid #ccc;
    padding: 15px;
    word-break: break-word;
  }

  .item-right {
    width: 50%;
    padding: 15px;
  }
}

.referenceInfoDialog {
  overflow: auto;

}
.i-known {
  text-align: center;
  margin: 15px 0;;
}
</style>
<style lang="scss">
.referenceInformation {
  .el-dialog {
    margin: 15vh auto 50px 15%;
  }
  .el-dialog__wrapper {
    left: 440px;
  }
}
</style>